<template>
  <div class="window" v-show="isVisible">
    <span class="close" title="Закрыть" @click="closeWindow"><img src="../image/cancel.svg"></span>
    <div class="window-title" v-if="alertHeader">{{ alertHeader }}</div>
    <div class="window-text" v-html="alertMessage"></div>
  </div>
</template>

<script>
    import utils from '@/utils'

    export default {
  name: 'AlertWindow',
  data () {
    return {
      isVisible: false,
      alertHeader: '',
      alertMessage: '',
      removeShadowAfterClosing: true,
      afterCloseFunction: null
    }
  },

  methods: {
    show (alertHeader, alertMessage, removeSchadow, afterCloseFunction) {
      if (removeSchadow !== undefined && removeSchadow === false) {
        this.removeShadowAfterClosing = false
      }
      this.alertHeader = alertHeader
      this.alertMessage = alertMessage
      utils.changeShadowVisibility(true)
      this.isVisible = true
      this.afterCloseFunction = afterCloseFunction
    },

    closeWindow () {
      this.isVisible = false
      this.alertHeader = ''
      this.alertMessage = ''
      if (this.removeShadowAfterClosing) {
        utils.changeShadowVisibility(false)
      } else {
        this.removeShadowAfterClosing = true
      }
      if (this.afterCloseFunction) {
        this.afterCloseFunction()
      }
    }
  }
}
</script>
